export default __webpack_public_path__ + "static/media/ZEN_UST.1ff420f6.svg";